import { colonyAPI } from '@/api';

import * as types from './mutation-types';

export default {
  login({ commit, dispatch }, credentials) {
    commit(types.LOGIN_REQUEST);
    colonyAPI
      .post('api-token-auth/', credentials)
      .then(response => {
        commit(types.LOGIN_SUCCESS, response);
        dispatch('user/getMe', {}, { root: true });
      })
      .catch(error => commit(types.LOGIN_FAILURE, error));
  },

  resetPassword({ commit, dispatch }, emailAddress) {
    commit(types.PASSWORD_RESET_REQUEST);
    colonyAPI
      .post('accounts/users/password-reset/', emailAddress)
      .then(response => dispatch('passwordResponseHandler', response))
      .catch(error => commit(types.PASSWORD_RESET_FAILURE, error));
  },
  updatePassword({ commit, dispatch }, payload) {
    const password = payload.password;
    const oldPassword = payload.oldPassword;
    commit(types.PASSWORD_RESET_REQUEST);
    colonyAPI
      .patch(`accounts/users/${payload.user}/`, { password, oldPassword })
      .then(response => dispatch('passwordResponseHandler', response))
      .catch(error => {
        commit(types.PASSWORD_RESET_FAILURE);
        if (error.response.status === 400) {
          dispatch('toast/error', 'Old password incorrect', {
            root: true,
          });
        } else {
          dispatch('toast/error', 'Failed to reset password. Try again later.', {
            root: true,
          });
        }
      });
  },
  updatePasswordOnUserList({ commit, dispatch }, payload) {
    const password = payload.password;
    const email = payload.email;
    commit(types.PASSWORD_RESET_REQUEST);
    colonyAPI
      .patch(`accounts/users/${payload.user}/`, { password, email })
      .then(response => dispatch('passwordResponseHandler', response))
      .catch(() => commit(types.PASSWORD_RESET_FAILURE));
  },
  tokenPasswordReset({ commit, dispatch }, payload) {
    const password = payload.password;
    commit(types.PASSWORD_RESET_REQUEST);
    colonyAPI
      .post(`accounts/users/${payload.token}/password-reset/`, { password })
      .then(response => dispatch('passwordResponseHandler', response))
      .catch(() => {
        commit(types.PASSWORD_RESET_FAILURE);
      });
  },
  passwordResponseHandler({ commit, dispatch }, response) {
    if (response.status === 200 || response.status === 201) {
      commit(types.PASSWORD_RESET_SUCCESS, response.data);
      dispatch('toast/success', 'Password has been reset.', {
        root: true,
      });
    } else {
      commit(types.PASSWORD_RESET_FAILURE);
      dispatch('toast/error', 'Failed to reset password. Try again later.', {
        root: true,
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js